import {
  type TemplateBuilderCondition,
  TemplateBuilderConditionOperator,
} from '@/gen/inventory/v1/template_builder_lib_pb'

/**
 * Checks whether a conditional question's visibility condition is met,
 * given the selected option IDs on the referenced parent question.
 *
 * For IS_ONE_OF: requires at least one selected option to match.
 * For IS_NOT_ONE_OF: true when nothing is selected (no overlap by definition).
 */
export function isConditionMet(
  condition: TemplateBuilderCondition,
  selectedOptionIds: string[],
): boolean {
  const hasOverlap = condition.optionIds.some((id) => selectedOptionIds.includes(id))
  return condition.operator === TemplateBuilderConditionOperator.IS_ONE_OF
    ? hasOverlap
    : !hasOverlap
}
